module.exports = __webpack_public_path__ + "static/media/RHSlidingOutDark.7565c5a4.svg";